import React, { Component } from 'react';
import '../assets/css/dashmix.min.css';
import '../assets/css/themes/xwork.min.css'; //black theme
import '../assets/css/additional.css';
import { HashRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Error404 from '../app/core/layouts/error/404';

// Pages
import HomePage from './modules/home/home';
import Settings from './modules/administrator/settings/Settings';
import Chat from './modules/chat/Chat';
import Favorites from './modules/favorites/Favorites';
import Profile from './modules/profile/Profile';
import Users from './modules/administrator/users/Users';
import User from './modules/administrator/user/User';
import Devices from './modules/administrator/devices/Devices';
import Auth from './modules/auth/Auth';
import Recover from './modules/recover/Recover';
import Terms from './modules/terms/Terms';
import Shared from './modules/shared/Shared';
// End

class App extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Router>
                <Switch>
                    <Route path={"/"} exact component={Auth} />
                    <Route path={"/recover"} exact component={Recover} />
                    <Route path={"/terms"} exact component={Terms} />
                    <Route path={"/shared"} exact component={Shared} />
                    <Route path={"/app"} exact component={HomePage} />
                    {/* <Route path={"/chat"} exact component={Chat} /> */}
                    <Route path={"/users"} exact component={Users} />
                    {/* <Route path={"/favorites"} exact component={Favorites} /> */}
                    {/* <Route path={"/profile"} exact component={Profile} /> */}
                    <Route path={"/user"} exact component={User} />
                    <Route path={"/devices"} exact component={Devices} />
                    <Route path={"/administrator/settings"} exact component={Settings} />
                    <Route component={Error404} />
                </Switch>
            </Router>
        );
    }
}

export default App;
